var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Usuarios eliminados","storeName":"Deleted_users","sortable":"","canSearch":"","labelDelete":"Restaurar","canAdd":false,"canEdit":false,"canDelete":true,"titleDeleted":"Restaurar el registro","descriptionDeleted":"¿Quieres restaurar este registro?","next-link":"/admin/coins_refunds","breadcrumbs":[
    {
      text: 'Gestión de usuarios',
      disabled: false,
      href: '/admin/deleted_users'
    },
    {
      text: 'Usuarios eliminados',
      disabled: false,
      href: '#'
    },
  ]},scopedSlots:_vm._u([{key:"completed_name",fn:function({item}){return [_vm._v(" "+_vm._s(item.name || '')+" "+_vm._s(item.last_name || '')+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }